<div class="header-name-content">
  <div class="header-name-content-name">
    <ion-icon [hidden]="!user?.isCompany" name="business-outline"></ion-icon>
    <ion-icon [hidden]="user?.isCompany" name="person-outline"></ion-icon>
    <h2>Olá, {{ user?.firstName }}</h2>
  </div>
  <ion-icon (click)="onClickLogout()" name="log-out-outline"></ion-icon>
</div>
